import React, { useCallback, useMemo } from "react";
import { themeInterface } from "../interfaces";

const useCssVariables = () => {
   const useVariables =  useCallback(
      (scope:string, theme:themeInterface) => {
        return theme ? <style>
                {`
                    ${scope} {
                        ${theme.primary ? '--primary-color:' + theme.primary : ""} ;
                        ${theme.secondary ? '--secondary-color:' + theme.secondary : ""};
                        ${theme.tertiary ? '--tertiary-color:' + theme.tertiary : ""};
                        ${theme.background ? '--background-color:' + theme.background : ""};
                        font-family:${theme?.fontFamily || 'inherit'}
                    }
                `}
            </style> : null;
      },
      [],
    );


    return useVariables;
};

export default useCssVariables;